import { ITranslationKeys } from '../types/i18n';

// Definición de la estructura base de traducciones
export const DEFAULT_NAMESPACE = 'translation';

export type TranslationNamespace = typeof DEFAULT_NAMESPACE;

// Tipo para validación de claves de traducción
export type TranslationKey = keyof ITranslationKeys;

// Tipo para validación de rutas de traducción
export type TranslationPath = string & {
  _translationPath: never;
};

// Tipo para los idiomas soportados
export type SupportedLanguage = 'es' | 'en' | 'de' | 'ko' | 'zh';

// Interface para el contexto de idioma
export interface ILanguageContext {
  currentLanguage: SupportedLanguage;
  changeLanguage: (lang: SupportedLanguage) => Promise<void>;
  isLanguageSupported: (lang: string) => lang is SupportedLanguage;
}
